module.exports = __webpack_public_path__ + "img/certificate.50d2682c.png";